module.exports = __webpack_public_path__ + "static/img/ent-82.5b5ef55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-82.jpg
// module id = 7yGw
// module chunks = 52